import { QuestionSet } from '@kp/question-set/models/question-set.model';
import { Deserializable, JsonObject, Serializable } from '@ktypes/models';

export class PastReflectionsModel implements Deserializable<any, PastReflectionsModel>, Serializable<JsonObject> {
  constructor(
    public date?: Date,
    public isLoading?: boolean,
    public hasMoreQuestions?: boolean,
    public availableDates?: QuestionSet[][]
  ) {}

  public empty() {
    return new PastReflectionsModel(new Date(), true, true, []);
  }

  questionSetAt(index: number) {
    if (index < this.availableDates.length) {
      return this.availableDates[index];
    }
    return null;
  }

  copyWith(date?: Date, isLoading?: boolean, hasMoreQuestions?: boolean, availableDates?: QuestionSet[][]) {
    return new PastReflectionsModel(date, isLoading, hasMoreQuestions, availableDates);
  }

  deserialize(input: any): PastReflectionsModel {
    if (input == null || input.values == null) {
      return null;
    }
    this.date = input.date;
    this.isLoading = input.isLoading;
    this.hasMoreQuestions = input.hasMoreQuestions;
    this.availableDates = Array.isArray(input.values) && input.values.map((value) => this.empty().deserialize(value));
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['date'] = this.date;
    json['available_dates'] = this.availableDates;
    return json;
  }
}
